export type DownloadStep =
  | 'requesting'
  | 'fetching'
  | 'chunk-progress'
  | 'stored'
  | 'decrypting'
  | 'complete'
  | 'error';

export const DOWNLOAD_STEP_LABELS: Record<DownloadStep, string> = {
  requesting: '3. Requesting from network',
  fetching: '4. Fetching blocks',
  'chunk-progress': '4. Fetching blocks',
  stored: '5. File stored',
  decrypting: '6. Decrypting',
  complete: '7. Complete',
  error: 'ERROR',
};

export abstract class CidDownloadLogger {
  abstract log(
    cid: string,
    step: DownloadStep,
    details?: Record<string, unknown>
  ): void;
}
